"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Atm = function Atm(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M21.063 10.75h-.625a.312.312 0 01-.313-.313V8.25H3.875v2.188c0 .172-.14.312-.313.312h-.624a.312.312 0 01-.313-.313V7.626c0-.345.28-.625.625-.625h17.5c.345 0 .625.28.625.625v2.813c0 .172-.14.312-.313.312zM12 12.938c-1.143 0-1.875-.977-1.875-2.5v-.626c0-.172.14-.312.313-.312h3.124c.173 0 .313.14.313.313v.624c0 1.524-.732 2.5-1.875 2.5zM5.437 9.5h.625c.173 0 .313.14.313.313v2.5c.914 0 1.695.66 1.847 1.562h7.556a1.874 1.874 0 011.847-1.563v-2.5c0-.172.14-.312.313-.312h.625c.172 0 .312.14.312.313V14.5c0 .345-.28.625-.625.625H5.75a.625.625 0 01-.625-.625V9.812c0-.172.14-.312.313-.312zm.625 6.25h11.875c.173 0 .313.14.313.313v.312c0 .345-.28.625-.625.625H6.375a.625.625 0 01-.625-.625v-.313c0-.172.14-.312.313-.312z"
  }));
};

var _default = (0, _react.forwardRef)(Atm);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Atm, "Atm", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Atm.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Atm.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9BdG0udHN4Il0sIm5hbWVzIjpbIkF0bSIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxHQUFtRSxHQUFHLFNBQXRFQSxHQUFzRSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUMxRTtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxJQUFJLEVBQUMsY0FEUDtBQUVFLElBQUEsQ0FBQyxFQUFDO0FBRkosSUFERixDQUQwRTtBQUFBLENBQTVFOztlQVNlLHVCQUFXRixHQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLEciLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEF0bTogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMjEuMDYzIDEwLjc1aC0uNjI1YS4zMTIuMzEyIDAgMDEtLjMxMy0uMzEzVjguMjVIMy44NzV2Mi4xODhjMCAuMTcyLS4xNC4zMTItLjMxMy4zMTJoLS42MjRhLjMxMi4zMTIgMCAwMS0uMzEzLS4zMTNWNy42MjZjMC0uMzQ1LjI4LS42MjUuNjI1LS42MjVoMTcuNWMuMzQ1IDAgLjYyNS4yOC42MjUuNjI1djIuODEzYzAgLjE3Mi0uMTQuMzEyLS4zMTMuMzEyek0xMiAxMi45MzhjLTEuMTQzIDAtMS44NzUtLjk3Ny0xLjg3NS0yLjV2LS42MjZjMC0uMTcyLjE0LS4zMTIuMzEzLS4zMTJoMy4xMjRjLjE3MyAwIC4zMTMuMTQuMzEzLjMxM3YuNjI0YzAgMS41MjQtLjczMiAyLjUtMS44NzUgMi41ek01LjQzNyA5LjVoLjYyNWMuMTczIDAgLjMxMy4xNC4zMTMuMzEzdjIuNWMuOTE0IDAgMS42OTUuNjYgMS44NDcgMS41NjJoNy41NTZhMS44NzQgMS44NzQgMCAwMTEuODQ3LTEuNTYzdi0yLjVjMC0uMTcyLjE0LS4zMTIuMzEzLS4zMTJoLjYyNWMuMTcyIDAgLjMxMi4xNC4zMTIuMzEzVjE0LjVjMCAuMzQ1LS4yOC42MjUtLjYyNS42MjVINS43NWEuNjI1LjYyNSAwIDAxLS42MjUtLjYyNVY5LjgxMmMwLS4xNzIuMTQtLjMxMi4zMTMtLjMxMnptLjYyNSA2LjI1aDExLjg3NWMuMTczIDAgLjMxMy4xNC4zMTMuMzEzdi4zMTJjMCAuMzQ1LS4yOC42MjUtLjYyNS42MjVINi4zNzVhLjYyNS42MjUgMCAwMS0uNjI1LS42MjV2LS4zMTNjMC0uMTcyLjE0LS4zMTIuMzEzLS4zMTJ6XCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoQXRtKTtcbiJdfQ==